import React from "react";
import { Text, Flex, SimpleGrid } from "@chakra-ui/react";
import type { VariantType } from "@shared/graphql.types";
import { GenericMarkdown } from "../GenericMarkdown";

type Props = {
  variant: VariantType;
};

export const FormulatedWith: React.FC<Props> = ({ variant }) => {
  const ingredients = variant.formula?.ingredients;
  const formulatedWithout = variant?.formula?.formulatedWithout;

  return (
    <SimpleGrid
      display="column"
      width={{ base: "100%" }}
      mt={{ base: 0, lg: 1 }}
    >
      <GenericMarkdown content={ingredients ?? ""} />

      {formulatedWithout && (
        <Flex direction="column" mt={3}>
          <Text variant="acuminRegular" mt={0}>
            {formulatedWithout?.label}
          </Text>
          <Text variant="acuminLight" mt={-1}>
            {formulatedWithout?.value}
          </Text>
        </Flex>
      )}
    </SimpleGrid>
  );
};
